import { c as _c } from "react/compiler-runtime";
import { useAuth } from '@clerk/nextjs';
import useSWR from 'swr';
import authApiInterface from '../services/auth-api-interface';
export default function useUser() {
  const $ = _c(6);
  const {
    getToken,
    isSignedIn,
    isLoaded
  } = useAuth();
  const fetcher = _temp;
  let t0;
  if ($[0] !== getToken) {
    t0 = () => fetcher(getToken);
    $[0] = getToken;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data,
    error,
    isLoading
  } = useSWR(isLoaded && isSignedIn ? "/api/v1/plain-user" : null, t0);
  const t1 = !isLoaded || isLoading;
  let t2;
  if ($[2] !== data || $[3] !== error || $[4] !== t1) {
    t2 = {
      user: data,
      isLoading: t1,
      isError: error
    };
    $[2] = data;
    $[3] = error;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
async function _temp(getToken_0) {
  return await authApiInterface.fetchPlainUser(getToken_0);
}